import {action, computed, decorate, observable} from "mobx";
import {
  MLB_SPORT_ID,
  TRIPLE_A_SPORT_ID,
  DOUBLE_A_SPORT_ID,
  HIGH_A_SPORT_ID,
  SINGLE_A_SPORT_ID,
  MINORS_SPORT_ID
} from "../utils/constants";

const MILB_EXPERIENCE_SPORT_IDS = [
  TRIPLE_A_SPORT_ID,
  DOUBLE_A_SPORT_ID,
  HIGH_A_SPORT_ID,
  SINGLE_A_SPORT_ID,
  MINORS_SPORT_ID
];

class SportsReferenceStore {

  constructor(sportyGateway, experienceStore) {
    this.sportyGateway = sportyGateway;
    this.experienceStore = experienceStore;
    this._sports = [];

    this.initialize();
  }

  initialize() {
    this.loadSports();
  }

  get sports() {
    if (this.experienceStore.isMilbExperience) {
      return this._sports.filter(s => MILB_EXPERIENCE_SPORT_IDS.includes(s.id));
    }
    return this._sports;
  }

  // Ideally, derive default sport from `loadSports()`. However, if not available, fallback to predefined consts.
  get defaultSport() {
    return this.sports.length > 0 && this.sports[0]
        ? this.sports[0].id
        : this.experienceStore.isMilbExperience
            ? TRIPLE_A_SPORT_ID
            : MLB_SPORT_ID;
  }

  loadSports() {
    return this.sportyGateway
    .getAllowedSports()
    .then(sports => (this._sports = sports));
  }
}

decorate(SportsReferenceStore, {
  _sports: observable,
  sports: computed,
  defaultSport: computed,
  loadSports: action
});

export default SportsReferenceStore;



// WEBPACK FOOTER //
// ./src/stores/SportsReferenceStore.js